// Decide si esta sesión monta el shell móvil (m.appeva.app) en lugar de la SPA
import { safeStorage } from './safeStorage';
// de escritorio. La señal real es el hostname (m.*); para desarrollo existe un
// override por query (?mobile=1 lo activa y persiste, ?mobile=0 lo apaga)
// porque en los stacks locales/evaverify no hay subdominio m.
const OVERRIDE_KEY = 'eva_mobile_shell';

/** Hostname real de subdominio móvil (m.appeva.app). No mira el override. */
export function isMobileHostname(): boolean {
  return /^m\./i.test(window.location.hostname);
}

export function isMobileHost(): boolean {
  if (isMobileHostname()) return true;
  try {
    const q = new URLSearchParams(window.location.search).get('mobile');
    if (q === '1') safeStorage.setItem(OVERRIDE_KEY, '1');
    else if (q === '0') safeStorage.removeItem(OVERRIDE_KEY);
    return safeStorage.getItem(OVERRIDE_KEY) === '1';
  } catch {
    return false;
  }
}

const PREFER_WEB_KEY = 'eva_prefer_web';

export function mobileRedirectTarget(location: Pick<Location, 'hostname' | 'pathname' | 'search' | 'hash'>, device: { userAgent: string; maxTouchPoints?: number }): string | null {
  const { hostname, pathname, search, hash } = location;
  if (!/^(www\.)?appeva\.app$/i.test(hostname)) return null;
  const mobile = /Android|iPhone|iPad|iPod/i.test(device.userAgent)
    || (/Macintosh/i.test(device.userAgent) && (device.maxTouchPoints || 0) > 1);
  if (!mobile) return null;
  // OAuth callbacks must finish in the window/origin that opened them.
  if (pathname.startsWith('/auth/') || /^\/(blog|admin|privacidad|terminos|retencion-datos|almacenamiento-datos|eliminacion-datos|uso-aceptable|aviso-ia|acuerdo-instituciones)(\/|$)/.test(pathname)) return null;
  const appPath = pathname === '/' || /^\/(teacher|student|login|register|forgot-password|reset-password|exam|material|clase|inicio|mi-ensenanza|examenes|libreta|grupos|tareas|planeador|materias|materiales|documentos|plantillas|bitacora|carrera|comunidad|integraciones|ajustes|analitica|alumnos|resultados|academia|institucion|director|instalar|descargar|app|pro|anuncios|billing)(\/|$)/.test(pathname);
  return appPath ? `https://m.appeva.app${pathname}${search}${hash}` : null;
}

/** Mobile and tablet entry to the production app, including the landing.
 * Preserve OAuth callback origins and explicit ?web=1 desktop preference. */
export function redirectPhoneToMobileHost(): boolean {
  const { hostname, search } = window.location;
  if (isMobileHostname()) return false;
  if (!/^(www\.)?appeva\.app$/i.test(hostname)) return false;
  try {
    const q = new URLSearchParams(search).get('web');
    if (q === '1') {
      safeStorage.setItem(PREFER_WEB_KEY, '1');
      return false;
    }
    if (q === '0') safeStorage.removeItem(PREFER_WEB_KEY);
    if (safeStorage.getItem(PREFER_WEB_KEY) === '1') return false;
  } catch {
    // The hostname guard prevents loops even when storage is unavailable.
  }
  const target = mobileRedirectTarget(window.location, navigator);
  if (!target) return false;
  window.location.replace(target);
  return true;
}
